import { WelcomeWeb } from '@/modules/welcome';
import React from 'react';

export default function WelcomeWebRoute() {
    return <WelcomeWeb />;
}
